/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
    Typography, Box, Card, IconButton,
} from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ViewListIcon from "@mui/icons-material/ViewList";
import RememberMeIcon from '@mui/icons-material/RememberMe';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import * as Actions from "actions/core/core.actions";

// Import the actual page components
import ShopOrdersList from "components/pages/user/orders/ShopOrderList";
import ShopOrderDetail from "components/pages/user/orders/ShopOrderDetail";
import ShopWishList from "components/pages/user/favourites/ShopWishList";
import ShopUserAppointments from "components/pages/user/appointments/ShopUserAppointments";
import ProfileAddresses from "components/pages/core/ProfileAddresses";
import UserProductsTryouts from "components/pages/user/products/UserProductsTryouts";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";
import PortraitIcon from '@mui/icons-material/Portrait';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

import {getURI, isAuthorized, isMarketPlace} from "helpers/utils";
import VirtualTryOnProfileImageEditor from "components/widgets/user/VirtualTryOnProfileImageEditor";
import UnifiedSwipeTrigger from "../../../../elements/main/UnifiedSwipeTrigger";

const ShopAccountTabContent = (props) => {
    const {
        history, shopId, location, logout
    } = props;

    // Determine current sub-page based on URL
    const getCurrentSubPage = () => {
        const path = location.pathname;
        if (path.includes('/orders/')) {
            const orderId = path.split('/orders/')[1];
            return { type: 'order-detail', orderId };
        } else if (path.includes('/orders')) {
            return { type: 'orders-list' };
        } else if (path.includes('/wishlist')) {
            return { type: 'wishlist' };
        } else if (path.includes('/appointments')) {
            return { type: 'appointments' };
        } else if (path.includes('/mytryons')) {
            return { type: 'mytryons' };
        } else if (path.includes('/tryonprofile')) {
            return { type: 'tryonprofile' };
        } else if (path.includes('/addresses')) {
            return { type: 'addresses' };
        }
        return { type: 'main' };
    };

    const currentSubPage = getCurrentSubPage();

    const handlePage = (page) => () => {

        const basePath = isMarketPlace() ? `/shop/${shopId}` : '';

        switch (page) {
            case "orders":
                history.push(`${basePath}/account/orders`);
                break;
            case "wishlist":
                history.push(`${basePath}/account/wishlist`);
                break;
            case "appointments":
                history.push(`${basePath}/account/appointments`);
                break;
            case "addresses":
                history.push(`${basePath}/account/addresses`);
                break;
            case "mytryons":
                history.push(`${basePath}/account/mytryons`);
                break;
            case "tryonprofile":
                history.push(`${basePath}/account/tryonprofile`);
                break;
            case "account":
            default:
                history.push(`${basePath}/account`);
                break;
        }

        history.push({
            pathname: page,
        });
    };

    const handleBackToAccount = () => {
        const basePath = isMarketPlace() ? `/shop/${shopId}/account` : '/account';
        history.push(basePath);
    };

    const handleBackHistory = () => {
        history.goBack();
    };

    const handleLogout = () => {
        localStorage.clear();
        logout();
    };

    const renderSubPageHeader = (title) => (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mb: 3,
            pb: 2,
            borderBottom: '1px solid #e0e0e0'
        }}>
            <IconButton 
                onClick={handleBackToAccount}
                sx={{ mr: 2 }}
            >
                <ArrowUpwardOutlinedIcon />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
            </IconButton>

        </Box>
    );

    const renderMainAccountPage = () => (
        <Box>
            <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handlePage(`orders`)}>
                                <IconButton size="large">
                                    <ViewListIcon />
                                </IconButton>
                                Orders
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>

            <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handlePage(`mytryons`)}>
                                <IconButton size="large">
                                    <PeopleAltIcon />
                                </IconButton>
                                 My "Try-Ons"
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>

            <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handlePage("tryonprofile")}>
                                <IconButton size="large">
                                    <PortraitIcon />
                                </IconButton>
                                "Try-On" Profiles
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>

            <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handlePage(`wishlist`)}>
                                <IconButton size="large">
                                    <FavoriteIcon />
                                </IconButton>
                                Wishlist
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>

            <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handlePage(`appointments`)}>
                                <IconButton size="large">
                                    <RememberMeIcon />
                                </IconButton>
                                Video Call Appointments
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>

            { isAuthorized() && <Box m={2}>
                <Card>
                    <Box display="flex">
                        <Box width="80%">
                            <Typography className="cursor-pointer" onClick={handleLogout}>
                                <IconButton size="large">
                                    <ExitToAppRoundedIcon />
                                </IconButton>
                                Logout
                            </Typography>
                        </Box>
                        <Box width="20%">
                            <Typography align="right">
                                <IconButton size="large">
                                    <KeyboardArrowRightRoundedIcon />
                                </IconButton>
                            </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>
            }

        </Box>
    );

    const renderSubPageContent = () => {
        switch (currentSubPage.type) {
            case 'orders-list':
                return (
                    <Box>
                        {renderSubPageHeader('My Orders')}
                        <ShopOrdersList {...props} />
                    </Box>
                );
            case 'order-detail':
                return (
                    <Box>
                        {renderSubPageHeader('Order Details')}
                        <ShopOrderDetail {...props} />
                    </Box>
                );
            case 'wishlist':
                return (
                    <Box>
                        {renderSubPageHeader('My Wishlist')}
                        <ShopWishList {...props} />
                    </Box>
                );
            case 'addresses':
                return (
                    <Box>
                        {renderSubPageHeader('Delivery Address')}
                        <ProfileAddresses {...props} />
                    </Box>
                );

            case 'mytryons':
                return (
                    <Box>
                        {renderSubPageHeader('My "Try-Ons"')}
                        <UserProductsTryouts includeHeader={false} {...props} />
                    </Box>
                );

            case 'tryonprofile':
                return (
                    <Box>
                        {renderSubPageHeader('Try-On Profile')}
                        <VirtualTryOnProfileImageEditor {...props} />
                    </Box>
                );

            case 'appointments':
                return (
                    <Box>
                        {renderSubPageHeader('My Appointments')}
                        <ShopUserAppointments {...props} />
                    </Box>
                );
            default:
                return renderMainAccountPage();
        }
    };

    return (
        <>
            { renderSubPageContent() }
            <UnifiedSwipeTrigger onLeftSwipeComplete={() => { handleBackHistory() }} />
        </>
    );
};

ShopAccountTabContent.propTypes = {
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    shopId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
};

// Mapping Props and State.
const _ShopAccountTabContent = connect(
    ({ bootupInfo }) => ({
        bootupInfo,
        reqStatus: bootupInfo.reqStatus,
        isLoading: bootupInfo.isLoading,
        serviceError: bootupInfo.serviceError,
        userDetails: bootupInfo.userDetails,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopAccountTabContent);

export { _ShopAccountTabContent as default };
